"use strict";

class DecoCircle{
	constructor($con){
		this.$con = $con;
		
		let h = '';
		h += '<span class="c1"></span>';
		h += '<span class="c2"></span>';
		h += '<span class="c3"></span>';
		h += '<span class="c4"></span>';
		h += '<span class="c5"></span>';
		h += '<span class="c6"></span>';
		this.$con.append(h);
		
		this.$con.find('span').velocity({scaleX:0,scaleY:0},1);
	}
	
	open(){
		this.$con.find('span').each((i,v)=>{
			$(v).velocity('stop').velocity({scaleX:1,scaleY:1},{duration:500,easing:[250,15],delay:i*60})
		});
	}
	
	close(){
		this.$con.find('span').each((i,v)=>{
			$(v).velocity('stop').velocity({scaleX:0,scaleY:0},{duration:100,easing:'swing',delay:i*60})
		});
	}
}

export default DecoCircle;


// WEBPACK FOOTER //
// ./js/parts/decocircle.js